import React from 'react'
import ReactMarkdown from 'react-markdown'
import remarkBehead from 'remark-behead'
import remarkGfm from 'remark-gfm'

import { MarkdownContent } from './styles'

interface MarkdownProps {
    text: string
    headingStartLevel?: 2 | 3 | 4 | 5 | 6
}

const Markdown: React.VFC<MarkdownProps> = ({ text, headingStartLevel = 2 }) => (
    <MarkdownContent>
        <ReactMarkdown remarkPlugins={[remarkGfm, [remarkBehead, { minDepth: headingStartLevel }]]}>
            {text}
        </ReactMarkdown>
    </MarkdownContent>
)

export default Markdown
